import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteSimilarTasksFromGroup = api(async function deleteSimilarTasksFromGroup({
    projectId,
    groupId,
    taskIds,
}) {
    return mutate(
        gql`
            mutation DeleteSimilarTasksFromGroup($projectId: String!, $groupId: String!, $taskIds: [String!]!) {
                deleteSimilarTasksFromGroup(projectId: $projectId, groupId: $groupId, taskIds: $taskIds)
            }
        `,
        { projectId, groupId, taskIds },
        { returns: "deleteSimilarTasksFromGroup" }
    )
})
